module.exports = "/images/pc.4bed0f7adc6636fd9db8695b5d8e1985.svg";